const projects = [
  {
    title: 'Architectural Grounding',
    catchPhrase: 'Build with understanding.',
    description: 'A strong architectural foundation enables clear reasoning from concept to construction — solving spatial and technical challenges through design thinking.',
    imageClass: "cap-1"
  },
  {
    title: 'Engineering Integration',
    catchPhrase: 'Build through expertise.',
    description: 'Engineering expertise connects design with fabrication — turning intent into precise, buildable solutions through technical insight and material understanding.',
    imageClass: "cap-2"
  },
  {
    title: 'Computational Methodology',
    catchPhrase: 'Build before it’s built.',
    description: 'By simulating complex geometries and fabrication processes, computation allows problems to be built — and solved — before they exist on site.',
    imageClass: "cap-3"
  }
];
export default projects;
